import Vue from 'vue'
import date from '@/components/kit/date'

const zeroPad = (num, places) => String(num).padStart(places, '0')

export const mapNumberToHour = (value, withSeconds) => {
  return `${zeroPad(value, 2)}:00`
}
Vue.prototype.$mapNumberToHour = mapNumberToHour

export const mapDateToTextOrNull = (value, i18nKey, i18n) => {
  if (!value) {
    return null
  }
  const date = new Date(value)
  if (i18nKey) {
    return `${i18n.t(i18nKey)} ${date.toLocaleDateString()}`
  }
  return `${date.toLocaleDateString()}`
}
Vue.prototype.$mapDateToTextOrNull = mapDateToTextOrNull

export const countDownFromDates = (purchaseDate, expirationDate) => {
  const expires = new Date(expirationDate)
  const purchased = new Date(purchaseDate)
  const now = new Date()

  return {
    value: date.daysBetween(expires, now),
    max: date.daysBetween(expires, purchased),
    color: 'green-mid'
  }
}
Vue.prototype.$countDownFromDates = countDownFromDates

export default (ctx, inject) => {
  const mapFrequencyTranslation = (obj) => {
    if (obj && obj.frequency) {
      return ctx.app.i18n.tc(obj.frequency, [obj.duration], {
        count: obj.duration
      })
    }
  }
  inject('mapFrequencyTranslation', mapFrequencyTranslation)

  const parseUrl = (url) => {
    const parser = document.createElement('a')
    // Let the browser do the work
    parser.href = url
    // Convert query string to object
    const queries = parser.search.replace(/^\?/, '').split('&')
    const query = {}
    for (let i = 0; i < queries.length; i++) {
      const split = queries[i].split('=')
      const value = decodeURIComponent(split[1])
      query[decodeURIComponent(split[0])] = value
    }

    const result = {
      protocol: parser.protocol,
      host: parser.host,
      hostname: parser.hostname,
      port: parser.port,
      pathname: parser.pathname,
      search: parser.search,
      query,
      hash: parser.hash
    }
    parser.remove()
    return result
  }
  inject('parseUrl', parseUrl)
  ctx.$parseUrl = parseUrl

  inject('mapNumberToHour', mapNumberToHour)
  ctx.$mapNumberToHour = mapNumberToHour
  inject('mapDateToTextOrNull', mapDateToTextOrNull)
  ctx.$mapDateToTextOrNull = mapDateToTextOrNull
  inject('countDownFromDates', countDownFromDates)
  ctx.$countDownFromDates = countDownFromDates
}
